/** A successfully loaded direct report clears its browser-local unread notification. */
import { useEffect } from 'react'
import { useShopifyStudyActivity } from '../../ShopifyStudyActivityContext'

export function useDirectReportRead(loadedRunId: string | null) {
  const { markReportRead } = useShopifyStudyActivity()
  useEffect(() => {
    if (loadedRunId) markReportRead(loadedRunId)
  }, [loadedRunId, markReportRead])
}
